// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { ContactAuditList } from '@/contact/components/contact-audit-list';
import { Stack } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';

export const Route = createFileRoute('/_app/contacts/$contactKey/audit')({
  component: ContactAuditRoute,
});

function ContactAuditRoute() {
  const { contactKey } = Route.useParams();

  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack paddingTop={2}>
        <Suspense>
          <ContactAuditList contactKey={contactKey} />
        </Suspense>
      </Stack>
    </HardfinTabCardWrapper>
  );
}
